function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { Dropdown as FabricDropDown } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export { DropdownMenuItemType } from 'office-ui-fabric-react';
export const Dropdown = props => {
  let dropdownProps = _objectSpread({}, props);
  // This comes from a requirement that Kavin gave us that if there is only one item
  // we must pre select it...
  if (props.options.length === 1 && props.selectedKey === undefined) {
    const defaultValueKey = props.options[0].key;
    dropdownProps = _objectSpread(_objectSpread({}, dropdownProps), {}, {
      selectedKey: defaultValueKey
    });
  }
  const isMinimalItemsLength = props.selectedKeys && props.minSelectedItems ? props.selectedKeys.length <= props.minSelectedItems : false;
  const getSelectedSortedToTop = () => {
    var _props$selectedKeys;
    if (!props.multiSelect || !((_props$selectedKeys = props.selectedKeys) !== null && _props$selectedKeys !== void 0 && _props$selectedKeys.length)) {
      return props.options;
    }
    const newOptions = [];
    props.selectedKeys.forEach(key => {
      const selectedItem = props.options.find(item => item.key === key);
      if (selectedItem) {
        newOptions.push(selectedItem);
      }
    });
    const otherOptions = props.options.filter(item => newOptions.indexOf(item) === -1);
    newOptions.push(...otherOptions);
    return newOptions;
  };
  const rowHeight = 36;
  dropdownProps = _objectSpread(_objectSpread({}, dropdownProps), {}, {
    styles: _objectSpread(_objectSpread({}, props.styles), {}, {
      label: {
        color: 'black'
      },
      dropdownItem: {
        height: rowHeight
      },
      dropdownItemsWrapper: {
        maxHeight: props.maxItemsOverlay && props.maxItemsOverlay * rowHeight,
        overflowY: 'auto'
      },
      dropdownItemSelected: isMinimalItemsLength && {
        pointerEvents: 'none',
        opacity: 0.4
      }
    }),
    options: props.selectedItemsAlwaysOnTop ? getSelectedSortedToTop() : props.options,
    onRenderItem: (renderItemProps, defaultRender) => renderItemProps && defaultRender ? /*#__PURE__*/_jsx("div", {
      "data-id": props.dataIdLookup ? props.dataIdLookup(renderItemProps.text) : renderItemProps.title,
      onKeyDown: e => props.onOptionKeyDown && props.onOptionKeyDown(e, renderItemProps),
      children: defaultRender(_objectSpread({}, renderItemProps))
    }, renderItemProps.key) : null
  });
  return /*#__PURE__*/_jsx(FabricDropDown, _objectSpread({
    "data-id": props.dataId
  }, dropdownProps));
};